<template>
  <div class="ee-container">
    <h1>EE快速通道</h1>
    <div class="subtitle">EE快速通道</div>
    
    <div class="content">
      <p>快速通道是一个在线系统，用来管理技术永久人员的移民申请。自2015年1月开始，加拿大移民局把所有的联邦技术类移民申请纳入入了快速通道系统。快速通道包含3个移民项目：FSWP (Federal Skilled Worker Program 联邦技术人员类移民项目)、CEC (Canadian Experience Class 加拿大经验类移民项目)和FSTP (Federal Skilled Trades 加拿大技工类移民项目)。申请人要满足以上三种移民项目中至少一个移民项目的要求，先进入系统填选池表达移民的意向EOI (Expression of Interest)。然后系统根据评估标准对申请人进行打分，分数达到邀请线后，IRCC会向申请人发出移民申请邀请ITA (Invitation to Apply)。申请人需要在收到ITA邀请后的60天内向联邦政府递交正式的移民申请。同时申请人还可以通过快速通道申请省提名移民项目。快速通道是加拿大移民系统中拥有最大配额的移民途径，审理时间短，大部分快速通道的申请人可以在半年内获得加拿大永久居民身份。</p>
      
      <div class="image-container">
        <img src="../../assets/ttt2.jpg" alt="加拿大国会大厦">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EEView'
}
</script>

<style scoped>
.ee-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

h1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
}

.content {
  font-size: 16px;
  line-height: 1.8;
  color: #444;
}

.image-container {
  margin-top: 30px;
  text-align: center;
}

img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>